const initialState = {
    // Partner Details State
    partnerDetailsData: null,
    isPartnerDetailsLoading: false,
    partnerDetailsError: null,
    
    // Partner List State
    partnerListData: null,
    isPartnerListLoading: false,
    partnerListError: null,
};

const partnerReducer = (state = initialState, action) => {
    switch (action.type) {
        // Partner Details Cases
        case "GET_PARTNER_DETAILS_REQUEST":
            return {
                ...state,
                isPartnerDetailsLoading: true,
                partnerDetailsError: null
            };
            
        case "GET_PARTNER_DETAILS_SUCCESS":
            return {
                ...state,
                partnerDetailsData: action.payload,
                isPartnerDetailsLoading: false,
                partnerDetailsError: null
            };
            
        case "GET_PARTNER_DETAILS_FAILED":
            return {
                ...state,
                partnerDetailsData: null,
                isPartnerDetailsLoading: false,
                partnerDetailsError: action.payload
            };

        // Partner List Cases
        case "GET_PARTNER_LIST_REQUEST":
            return {
                ...state,
                isPartnerListLoading: true,
                partnerListError: null
            };
            
        case "GET_PARTNER_LIST_SUCCESS":
            return {
                ...state,
                partnerListData: action.payload,
                isPartnerListLoading: false,
                partnerListError: null
            };
            
        case "GET_PARTNER_LIST_FAILED":
            return {
                ...state,
                partnerListData: null,
                isPartnerListLoading: false,
                partnerListError: action.payload
            };

        default:
            return state;
    }
};

export default partnerReducer;